import { z } from "zod";

export const organizationStatusEnum = z.enum([
  "ACTIVE", // fully functional.  Active data will appear in all of your lists and reports.
  "INCATIVE", // use this for when an org is late on payment but still using the software. This will tell the system to not allow any new users to be added to the org. And users won't be able to make appointments with this org (notif: Org X is currently not accepting Y).
  "ARCHIVED", // Still active, but hidden.  Putting things in the “archived” state is a way for you to shorten your lists.  Anything archived will not appear in invoicing/time tracking lists but they will appear under Reports
]);

export type OrganizationStatus = z.infer<typeof organizationStatusEnum>;
